module.exports = __webpack_public_path__ + "static/1-7b1252e8cfd1257eb599077468825c08.jpg";